(function(angular) {
    'use strict';

    angular.module('messenger')

    /**
     *
     */
    .factory('facebookSDKService',
        ['$http', '$q', 'portalConfig',
            function ($http, $q, portalConfig) {
                var _isLoaded = false;
                (function(d, s, id){
                    var js, fjs = d.getElementsByTagName(s)[0];
                    if (d.getElementById(id)) {return;}
                    js = d.createElement(s); js.id = id;
                    js.src = "//connect.facebook.net/en_US/all.js";
                    fjs.parentNode.insertBefore(js, fjs);
                }(document, 'script', 'facebook-jssdk'));


                var sdk = {
                    isLoaded: function () {
                        return _isLoaded;
                    },
                    init: function(args){
                        FB.init(args);
                        _isLoaded = true;
                    },
                    subscribe: function(name, callback){
                        FB.Event.subscribe(name, callback);
                    }
                };

                return sdk;

    }]);

})(window.angular);
